import { useTranslation } from "react-i18next";
import { PatientTag } from "../../../../models/endpoints/tags-endpoint.model";
import QuickViewPanelWrapper from "../../../../components/quick-view-panel-wrapper/QuickViewPanelWrapper";

const TagsQuickViewPanel = (props: {
	isLoading: boolean;
	isError: boolean;
	tags: PatientTag[] | undefined;
	onClickAction: () => void;
}) => {
	const { t } = useTranslation("common");

	const activeTags = props.tags ?? [];

	if (props.isLoading) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.TAGS.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data loading">
					<i className="pi pi-spin pi-spinner message-icon"></i>
					{t("PARTICIPANT.DASHBOARD.TAGS.MESSAGES.LOADING")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	if (props.isError) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.TAGS.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data has-error">
					{t("PARTICIPANT.DASHBOARD.TAGS.MESSAGES.ERROR")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	if (!activeTags.length) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.TAGS.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data">{t("PARTICIPANT.DASHBOARD.TAGS.MESSAGES.NO_DATA")}</p>
			</QuickViewPanelWrapper>
		);
	}

	return (
		<QuickViewPanelWrapper
			title="PARTICIPANT.DASHBOARD.TAGS.QUICK_VIEW.PANEL_TITLE"
			onClickAction={props.onClickAction}
			isLoading={props.isLoading}
			isError={props.isError}
		>
			<ul className="panel-list">
				{activeTags.map((tag) => (
					<li
						key={tag.id}
						className="panel-list-item tag-item"
					>
						<span
							className="tag-dot"
							style={{ backgroundColor: tag.color }}
						></span>
						<span className="item-label">{tag.name}</span>
						{tag.category && <span className="item-value">{tag.category}</span>}
					</li>
				))}
			</ul>
		</QuickViewPanelWrapper>
	);
};

export default TagsQuickViewPanel;
